import React, { Component } from 'react'
import { Text } from '@cred/react-text'
import Font from '@cred/react-font'
import Link from 'components/link'
import PropTypes from 'prop-types'
import Tooltip from 'components/tooltip'
import logo from '@cred/global-assets/images/logos/credible/logo-blue.svg'
import config from 'config'
import styles from './styles.scss'

class RateWidgetFooter extends Component {
  static propTypes = {
    theme: PropTypes.string,
    footerDisclosure: PropTypes.string,
    noMargin: PropTypes.bool,
    multiVertical: PropTypes.bool,
    offSet: PropTypes.string,
    containerClass: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = { hide: true }
  }

  static defaultProps = {
    footerDisclosure: "The rates that appear are from companies which Credible receives compensation. This compensation does not impact how or where products appear within the table. The rates and information shown do not include all financial service providers or all of the displayed lender's available services and product offerings.",
    noMargin: false,
    multiVertical: false,
    offSet: '',
  }

  componentDidMount() {
    this.setState({ hide: false })
  }


  render() {
    const { hide } = this.state,
      { theme, footerDisclosure, noMargin, multiVertical, offSet, containerClass } = this.props,
      partners = ['thebalance1', 'investopedia1', 'yahoo1'],
      hidePartners = ['thebalance1', 'investopedia1'],
      linkCss = partners.includes(theme) ? theme : '',
      linkFont = (theme === 'yahoo1') ? 'yahoo1Font' : '',
      showDisclosure = !hidePartners.includes(theme),
      smallerCls = multiVertical ? 'small' : '',
      poweredByCls = multiVertical ? 'poweredBy' : '',
      reverseCls = multiVertical ? 'reverse' : ''
    return (
      <div className={`${styles.container} ${styles[reverseCls]} ${containerClass || ''}`}>
        <div className={styles.links}>
          <Font type="disclaimer" className={`${multiVertical ? '' : 'mt-16'} ${noMargin ? '' : 'ml-md-16'} ${styles[linkFont]}`}>
            <Link type="disclaimer" color="secondary" rel="nofollow" className={`${styles[linkCss]} ${styles[smallerCls]}`} blank href={`${config.credibleRoot}/terms`}>Terms</Link>{' | '}
            <Link type="disclaimer" color="secondary" rel="nofollow" className={`${styles[linkCss]} ${styles[smallerCls]}`} blank href={`${config.credibleRoot}/privacy`}>Privacy Policy</Link>{ showDisclosure && ' | ' }
            { showDisclosure && <Link type="disclaimer" color="secondary" className={`${styles[linkCss]} ${styles[smallerCls]}`} data-tip data-for="disc-tooltip" data-offset={offSet}>Advertiser Disclosure</Link> }
          </Font>
          { !hide
            && (
            <Tooltip
              id="disc-tooltip"
              className="align-left"
              place="top"
              analyticsOptions={{ contentSubject: 'Advertiser Disclosure' }}
            >
              <Text type="disclaimer" className={styles.footerDisclosure}>
                <span>{footerDisclosure}</span>
              </Text>
            </Tooltip>
            )}
        </div>
        <div className={styles.logo}>
          <Font type="disclaimer" className={`${multiVertical ? '' : 'mt-8 mt-md-16'} ${styles[poweredByCls]}`}>Powered by <img alt="Credible logo" src={logo} className={`${noMargin ? '' : 'mr-md-16'}`} /></Font>
        </div>
      </div>
    )
  }
}

export { RateWidgetFooter }

export default RateWidgetFooter
